import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "./../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import { Lock, LockPasscode } from "@/api/locks";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { loadHandbooks } from "@/utils/loadHandbooks";

interface IEditPasscodeForm {
  passcode: string;
}

const editPasscodeFields: InputField[] = [
  {
    label: "Пароль",
    name: "passcode",
    placeholder: "Офис 1",
    type: "text",
    isRequired: true,
    pattern: /[0-9]{4}/,
    patternMessage: 'Пароль должен состоять из 4 цифр'
  },
];

export function EditPasscodeModal({
  disclosure,
  lock,
  passcode,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  lock: Lock | null;
  passcode: LockPasscode | null;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErros] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: IEditPasscodeForm) => {
    return new Promise<boolean>(async (resolve, _reject) => {
      api.locks
        .updatePasscode(lock!.id, passcode!.id, {
          passcode: data.passcode,
        })
        .then((_data) => {
          loadHandbooks({ handbooks: ["locks"] });
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          loadHandbooks({ handbooks: ["locks"] });
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  const onDelete = () => {
    return new Promise<boolean>(async (resolve, _reject) => {
      api.locks
        .deletePasscode(lock!.id, passcode!.id)
        .then((_data) => {
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Редактирование пароля"
      fields={editPasscodeFields}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      modalErrors={modalErrors}
      onSubmit={onSubmit}
      onDelete={onDelete}
      isSensitiveData={true}
      submitButtonText="Сохранить"
      defaultValues={{
        passcode: passcode?.passcode,
      }}
    />
  );
}
